import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications/notifications.component';
import { MaterialModule } from '../shared/material.module';



@NgModule({
  declarations: [NotificationsComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports:[
    NotificationsComponent
  ]
})
export class CoreModule { }
